import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

class OffersBookNowAction extends BaseAction<void, void> {
  override async run(): Promise<void | null> {
    if (this.params) {
      const { route, isAuthenticated } = this.params;
      updateRecoilState("searchStateAtom", route);
      if (isAuthenticated) {
        _eventBus.emit({
          eventName: "ROUTE_CHANGE",
          data: "/search",
        })
      } else {
        _eventBus.emit({
          eventName: "ROUTE_CHANGE",
          data: "/",
        })
      }
    }
  }
}

export const offersBookNowAction = new OffersBookNowAction();
